import { render } from "./product-categories.vue?vue&type=template&id=ce8c3e0a&scoped=true"
import script from "./product-categories.vue?vue&type=script&lang=js"
export * from "./product-categories.vue?vue&type=script&lang=js"

import "./product-categories.vue?vue&type=style&index=0&id=ce8c3e0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce8c3e0a"]])

export default __exports__